import { auth } from "../firebase";
import ENV from "../env";
const pending = new Map();
export const scanRequestId = () =>
  `scan-${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
export default async function scanTicket({ eventId, participantId, action = "toggle" }) {
  const user = auth.currentUser;
  if (!user) throw new Error("unauthenticated");
  const key = `${user.uid}:${eventId}:${participantId}:${action}`;
  if (!pending.has(key)) pending.set(key, scanRequestId());
  const token = await user.getIdToken();
  const response = await fetch(`${ENV.firebaseApiUrl}/participant/scan`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ eventId, participantId, action, requestId: pending.get(key) }),
  });
  const result = await response.json();
  if (response.status < 500) pending.delete(key);
  if (!response.ok) throw new Error(result.reason || "scan_failed");
  return result;
}
